import { Box, styled } from "@mui/material";

export const InfoArea = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: "0.5rem",
});

export const CardRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== "selected",
})<{ selected?: boolean }>(({ theme, selected }) => ({
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  padding: "16px 20px",
  borderRadius: "0.5rem",
  backgroundColor: theme.palette.background.card || "#2A2A2A",
  border: "1px solid transparent",
  transition: "border-color 0.15s ease",
  ...(selected && {
    borderColor: theme.palette.borderAccent,
  }),
  "&:hover": {
    borderColor: selected ? theme.palette.borderAccent : theme.palette.divider,
  },
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
    alignItems: "stretch",
    gap: "12px",
  },
}));
